module.exports = [
	{
		"age": "16",
		"thirtyDay": "186.38",
		"sixtyDay": "110.14",
		"ninetyDay": "82.3"
	},
	{
		"age": "17",
		"thirtyDay": "189.3",
		"sixtyDay": "112.29",
		"ninetyDay": "84.22"
	},
	{
		"age": "18",
		"thirtyDay": "192.19",
		"sixtyDay": "114.45",
		"ninetyDay": "86.15"
	},
	{
		"age": "19",
		"thirtyDay": "198.15",
		"sixtyDay": "118.42",
		"ninetyDay": "89.6"
	},
	{
		"age": "20",
		"thirtyDay": "206.2",
		"sixtyDay": "123.58",
		"ninetyDay": "93.91"
	},
	{
		"age": "21",
		"thirtyDay": "214.65",
		"sixtyDay": "129.18",
		"ninetyDay": "98.55"
	},
	{
		"age": "22",
		"thirtyDay": "224.48",
		"sixtyDay": "135.65",
		"ninetyDay": "103.8"
	},
	{
		"age": "23",
		"thirtyDay": "237.93",
		"sixtyDay": "144.24",
		"ninetyDay": "110.9"
	},
	{
		"age": "24",
		"thirtyDay": "251.37",
		"sixtyDay": "152.95",
		"ninetyDay": "118"
	},
	{
		"age": "25",
		"thirtyDay": "265.77",
		"sixtyDay": "162.21",
		"ninetyDay": "125.74"
	},
	{
		"age": "26",
		"thirtyDay": "280.47",
		"sixtyDay": "171.76",
		"ninetyDay": "133.6"
	},
	{
		"age": "27",
		"thirtyDay": "295.14",
		"sixtyDay": "181.34",
		"ninetyDay": "141.66"
	},
	{
		"age": "28",
		"thirtyDay": "311.22",
		"sixtyDay": "191.87",
		"ninetyDay": "150.27"
	},
	{
		"age": "29",
		"thirtyDay": "326.31",
		"sixtyDay": "201.76",
		"ninetyDay": "158.54"
	},
	{
		"age": "30",
		"thirtyDay": "341.7",
		"sixtyDay": "211.89",
		"ninetyDay": "167.02"
	},
	{
		"age": "31",
		"thirtyDay": "366.5",
		"sixtyDay": "227.8",
		"ninetyDay": "180.15"
	},
	{
		"age": "32",
		"thirtyDay": "390.87",
		"sixtyDay": "243.5",
		"ninetyDay": "192.94"
	},
	{
		"age": "33",
		"thirtyDay": "416.93",
		"sixtyDay": "260.17",
		"ninetyDay": "206.61"
	},
	{
		"age": "34",
		"thirtyDay": "443.67",
		"sixtyDay": "277.26",
		"ninetyDay": "220.48"
	},
	{
		"age": "35",
		"thirtyDay": "470.26",
		"sixtyDay": "294.25",
		"ninetyDay": "234.26"
	},
	{
		"age": "36",
		"thirtyDay": "494.08",
		"sixtyDay": "309.3",
		"ninetyDay": "246.6"
	},
	{
		"age": "37",
		"thirtyDay": "517.65",
		"sixtyDay": "324.25",
		"ninetyDay": "258.55"
	},
	{
		"age": "38",
		"thirtyDay": "540.36",
		"sixtyDay": "338.55",
		"ninetyDay": "270.05"
	},
	{
		"age": "39",
		"thirtyDay": "562.27",
		"sixtyDay": "352.22",
		"ninetyDay": "280.9"
	},
	{
		"age": "40",
		"thirtyDay": "582.07",
		"sixtyDay": "364.37",
		"ninetyDay": "290.49"
	},
	{
		"age": "41",
		"thirtyDay": "601.19",
		"sixtyDay": "376.1",
		"ninetyDay": "299.51"
	},
	{
		"age": "42",
		"thirtyDay": "619.07",
		"sixtyDay": "386.85",
		"ninetyDay": "307.7"
	},
	{
		"age": "43",
		"thirtyDay": "634.86",
		"sixtyDay": "396.09",
		"ninetyDay": "314.68"
	},
	{
		"age": "44",
		"thirtyDay": "647.89",
		"sixtyDay": "403.72",
		"ninetyDay": "320.16"
	},
	{
		"age": "45",
		"thirtyDay": "659.11",
		"sixtyDay": "409.95",
		"ninetyDay": "324.47"
	},
	{
		"age": "46",
		"thirtyDay": "671.44",
		"sixtyDay": "416.84",
		"ninetyDay": "329.19"
	},
	{
		"age": "47",
		"thirtyDay": "681.82",
		"sixtyDay": "422.44",
		"ninetyDay": "332.96"
	},
	{
		"age": "48",
		"thirtyDay": "690.42",
		"sixtyDay": "426.85",
		"ninetyDay": "335.67"
	},
	{
		"age": "49",
		"thirtyDay": "695.97",
		"sixtyDay": "429.32",
		"ninetyDay": "336.84"
	},
	{
		"age": "50",
		"thirtyDay": "699.84",
		"sixtyDay": "430.94",
		"ninetyDay": "337.38"
	},
	{
		"age": "51",
		"thirtyDay": "705.53",
		"sixtyDay": "433.61",
		"ninetyDay": "338.67"
	},
	{
		"age": "52",
		"thirtyDay": "707.88",
		"sixtyDay": "434.28",
		"ninetyDay": "338.44"
	},
	{
		"age": "53",
		"thirtyDay": "709.12",
		"sixtyDay": "434.38",
		"ninetyDay": "337.91"
	},
	{
		"age": "54",
		"thirtyDay": "707.88",
		"sixtyDay": "432.97",
		"ninetyDay": "336.32"
	},
	{
		"age": "55",
		"thirtyDay": "704.42",
		"sixtyDay": "430.5",
		"ninetyDay": "333.82"
	},
	{
		"age": "56",
		"thirtyDay": "696.94",
		"sixtyDay": "425.66",
		"ninetyDay": "329.75"
	},
	{
		"age": "57",
		"thirtyDay": "683.62",
		"sixtyDay": "417.38",
		"ninetyDay": "322.86"
	},
	{
		"age": "58",
		"thirtyDay": "663.54",
		"sixtyDay": "405.03",
		"ninetyDay": "312.96"
	},
	{
		"age": "59",
		"thirtyDay": "635",
		"sixtyDay": "388.04",
		"ninetyDay": "302.65"
	},
	{
		"age": "60",
		"thirtyDay": "621.85",
		"sixtyDay": "380.08",
		"ninetyDay": "293.17"
	},
	{
		"age": "61",
		"thirtyDay": "566.97",
		"sixtyDay": "345.76",
		"ninetyDay": "265.31"
	},
	{
		"age": "62",
		"thirtyDay": "524.73",
		"sixtyDay": "318.23",
		"ninetyDay": "241.56"
	},
	{
		"age": "63",
		"thirtyDay": "483.29",
		"sixtyDay": "287.46",
		"ninetyDay": "211.02"
	},
	{
		"age": "64",
		"thirtyDay": "341.84",
		"sixtyDay": "183.7",
		"ninetyDay": "111.01"
	}
];


//////////////////
// WEBPACK FOOTER
// C:/git/qsuper-fed/~/json-loader!./src/data/standardRateUnitisedSixtyFiveYear.json
// module id = 455
// module chunks = 0